import { observable } from "mobx";
import cities from "./data/cities.json";

class CitiesStore {
  @observable citiesList = [];

  constructor() {
    this.citiesList = cities;
  }

}

export default new CitiesStore();



// WEBPACK FOOTER //
// ./src/stores/citiesStore/index.js